import { validator } from "LIB/validate-this";
import { get } from "lodash";
import * as rules from "LIB/validation/rules";
import validateAttachment from "MODULES/Receiving/components/shared/FormSections/validate";
import { CONSIGNMENT } from "MODULES/Orders/shared/constants";
import {
  CONSIGNMENT_BUYER_ID,
  CONSIGNMENT_REFERENCE,
  CONSIGNMENT_REFERENCE_COMPANY_ID,
  CONSIGNOR_PERCENTAGE,
  EMA,
  INSPECTED,
  MISTAKE_SHIPMENT,
  OVERHAULED,
  RECEIVING_TYPE,
  REPAIRED,
  TAG_DATE_CONDITIONS
} from "MODULES/Receiving/constants";
import {
  CONDITION,
  EXPIRATION,
  LOCATION,
  NEW_ITEM,
  PART_ID,
  SERIAL_NUMBER,
  STORE_LOCATION_ID,
  TAG_DATE,
  TAGGED_BY
} from "MODULES/inventories/constants";
import { ATTACHMENTS, QUANTITY } from "APP_ROOT/constants";
import { DOM, DOM_SENSITIVE, PART, SHELF_LIFE } from "MODULES/parts/constants";
import { LOT, LOT_ID, LOT_LINE_ITEM } from "MODULES/Lots/constants";

export default function(values, props) {
  return validator(values, form => {
    form
      .validate(
        PART_ID,
        RECEIVING_TYPE,
        QUANTITY,
        CONDITION,
        STORE_LOCATION_ID,
        SERIAL_NUMBER
      )
      .satisfies(rules.required);
    if (
      TAG_DATE_CONDITIONS.includes(values.condition) &&
      ![MISTAKE_SHIPMENT, EMA, CONSIGNMENT].includes(values.receiving_type)
    ) {
      form.validate(TAG_DATE).satisfies(rules.required);
    }

    if (
      [CONSIGNMENT, EMA].includes(values.receiving_type) &&
      [OVERHAULED, REPAIRED, INSPECTED].includes(values.condition)
    ) {
      form.validate(TAG_DATE).satisfies(rules.required);
    }

    if (
      values.receiving_type === LOT_LINE_ITEM &&
      [OVERHAULED, REPAIRED, INSPECTED].includes(values.condition)
    ) {
      form.validate(TAGGED_BY).satisfies(rules.required);
    }

    if (values.receiving_type !== EMA) {
      form.validate(LOCATION).satisfies(rules.required);
    }

    if (values.receiving_type === LOT) {
      form.validate(LOT_ID).satisfies(rules.required);
    }

    if (
      CONSIGNMENT === values.receiving_type &&
      !get(props, "receivingRecord.type")
    )
      form.validate(CONSIGNMENT_REFERENCE).satisfies(rules.required);

    if (
      [CONSIGNMENT, EMA].includes(values.receiving_type) &&
      !get(props, "receivingRecord.type")
    ) {
      form
        .validate(
          CONSIGNMENT_BUYER_ID,
          CONSIGNOR_PERCENTAGE,
          CONSIGNMENT_REFERENCE_COMPANY_ID
        )
        .satisfies(rules.required);

      const minValFunc =
        values.receiving_type === EMA
          ? rules.isGreaterThanOrEqualTo
          : rules.isGreaterThan;

      form
        .validate(CONSIGNOR_PERCENTAGE)
        .satisfies(minValFunc(0.0), rules.isLessThanOrEqualTo(99));

      if ([OVERHAULED, REPAIRED, INSPECTED].includes(values.condition)) {
        form.validate(TAGGED_BY).satisfies(rules.required);
      }
    }

    if (
      get(props.receivingRecord, [PART, SHELF_LIFE].join(".")) &&
      [OVERHAULED, REPAIRED, INSPECTED, NEW_ITEM].includes(values.condition)
    ) {
      form.validate(EXPIRATION).satisfies(rules.required);
    }

    if (get(props.receivingRecord, [PART, DOM_SENSITIVE].join("."))) {
      form.validate(DOM).satisfies(rules.required);
    }

    form.validateChildren(ATTACHMENTS, validateAttachment);
  });
}



// WEBPACK FOOTER //
// ./app/modules/Receiving/Dashboard/Create/validate.js